import { createSelector } from 'reselect';

const baseSelectOpportunityPost = state => state.entities.opportunityPostBuilder.item;

export const selectOpportunityPostToEdit = createSelector([baseSelectOpportunityPost], item => {
  return item || {};
});
